import Loading from 'components/common/loading'
import moment from 'moment'
import { Button, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { updateStatusArtist } from 'services/admin'
import { IArtist, IStatusData } from 'services/type'
import { editItem } from 'store/artist/artistSlice'
import { selectArtist } from 'store/artist/selectors'
import copyText from 'utils/copy'
import { linkToProfile, linkToTwitter } from 'utils/link'
import { addressSplice } from 'wallet/utils'

export default function ArtistData({
  updateData,
}: {
  updateData?: () => void
}) {
  const { t } = useTranslation()
  const { data, isLoading, status } = useSelector(selectArtist)
  const dispatch = useDispatch()

  async function changeStatus(data: IArtist, status: IStatusData) {
    if (isLoading) return

    try {
      const rest = await updateStatusArtist({
        address: data.address,
        status,
      })
      if (!rest || rest.statusCode > 299) return

      dispatch(editItem({ ...data, status }))
      if (updateData) updateData()
    } catch (error) {
      console.error(error)
    }
  }

  function artworkLink(dataJSON: any): Array<string> {
    try {
      if (!dataJSON) return []
      let data = dataJSON || []
      if (typeof data === 'string') data = JSON.parse(dataJSON)
      if (typeof data === 'string') data = JSON.parse(JSON.parse(dataJSON))
      if (!data?.length) return []
      return data as Array<string>
    } catch (error) {
      return []
    }
  }

  return (
    <Table className='wa__table'>
      <thead>
        <tr>
          <th>{t('USER_NAME')}</th>
          <th>{t('WALLET_ADDRESS')}</th>
          <th>{t('EMAIL')}</th>
          <th>{t('INSTAGRAM')}</th>
          <th>{t('TWITTER')}</th>
          <th>{t('ARTWORK_LINK')}</th>
          <th>{t('ARTWORK_TYPES')}</th>
          <th>{t('SUBMIT_DATE')}</th>

          <th>
            {status == IStatusData.APPROVED && t('APPROVAL_DATE')}
            {status == IStatusData.DISAPPROVED && t('DISAPPROVAL_DATE')}
          </th>
        </tr>
      </thead>

      <tbody>
        {!isLoading &&
          data.map((obj, i) => (
            <tr key={i}>
              <td>
                <a
                  href={linkToProfile(obj.address)}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='wa__username text-line'
                >
                  {obj.userName}
                </a>
              </td>
              <td
                onClick={() => copyText(obj.address)}
                title={t('Click to copy')}
              >
                {addressSplice(obj.address, 6, 4)}
              </td>
              <td>{obj.email}</td>
              <td>
                <a
                  href={obj.instagramSite}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Instagram
                </a>
              </td>
              <td>
                {!!obj.twitter && (
                  <a
                    href={linkToTwitter(obj.twitter)}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    @{obj.twitter}
                  </a>
                )}
              </td>
              <td>
                <p className='wa__artist-link'>
                  {artworkLink(obj.firstAnswer).map((link, y) => (
                    <a
                      href={link}
                      target='_blank'
                      key={y}
                      rel='noreferrer'
                      style={{ display: 'block' }}
                    >
                      Artwork {y + 1}
                    </a>
                  ))}
                </p>
              </td>
              <td>
                <p
                  className='text-line--3 wa__secondAnswer'
                  title={obj.secondAnswer}
                >
                  {obj.secondAnswer}
                </p>
              </td>
              <td>{moment(obj.createdAt).format('L')}</td>

              <td>
                <p className='wa__g-action'>
                  {status == IStatusData.PENDING && (
                    <>
                      <Button
                        className='wa__action'
                        onClick={() => changeStatus(obj, IStatusData.APPROVED)}
                        variant='outline-primary'
                      >
                        {t('APPROVE')}
                      </Button>
                      <Button
                        className='wa__action'
                        onClick={() =>
                          changeStatus(obj, IStatusData.DISAPPROVED)
                        }
                        variant='outline-danger'
                      >
                        {t('DISAPPROVE')}
                      </Button>
                    </>
                  )}

                  {(status == IStatusData.APPROVED ||
                    status == IStatusData.DISAPPROVED) &&
                    moment(obj.updatedAt).format('L')}
                </p>
              </td>
            </tr>
          ))}

        {!isLoading && !data.length && (
          <tr>
            <td colSpan={9}>
              <div className='wa__no-data'>{t('NO_DATA')}</div>
            </td>
          </tr>
        )}

        {isLoading && (
          <tr>
            <td colSpan={9}>
              <div className='wa__loading'>
                <Loading />
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}
